/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable indent */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
import React, { useEffect } from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslation } from '@i18n';

import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import IconButton from '@material-ui/core/IconButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Hidden from '@material-ui/core/Hidden';
import Divider from '@material-ui/core/Divider';
import Skeleton from '@material-ui/lab/Skeleton';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

import { miniDrawerWidth, drawerWidth, isMenuAllowed } from '@modules/theme/layout/helpers';
import { GRAY_TITLE, PRIMARY } from '@theme_color';
import { getLocalStorage } from '@helper_localstorage';
import { storeConfigVar, storeConfigPimVar } from '@services/graphql/cache';

import Tooltip from '@common_tooltipseller';

const useStyles = makeStyles((theme) => ({
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: miniDrawerWidth,
        },
    },
    togleMenuButton: {
        width: 24,
        height: 24,
        position: 'absolute',
        top: '16px',
        right: '16px',
    },
    togleMenuIcon: {
        fontSize: 27,
        color: '#bE1f93',
        borderRadius: '3px',
        background: '#fff',
        boxShadow: '0px 3px 6px #DDE1EC',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    swiftOmsLogo: {
        cursor: 'pointer',
        padding: 12,
        '&.open': { justifyContent: 'flex-start' },
        '&.close': { justifyContent: 'center' },
        '& img': { height: 45 },
    },
    divMenu: {
        color: GRAY_TITLE,
        '& .itemText span': {
            fontWeight: 700,
            fontSize: 15,
            textTransform: 'capitalize',
        },
    },
    menuList: {
        padding: 0,
        '&.open': {
            paddingRight: 16,
        },
    },
    menuItem: {
        marginTop: 8,
        paddingLeft: 20,
        '&.open': { borderRadius: '0 26px 26px 0' },
        '&:hover': {
            background: '#ECF0FB',
            color: '#BE1F93',
        },
        '&.active': {
            background: '#ECF0FB',
            color: '#BE1F93',
            '& .itemIcon img': {
                filter: 'invert(24%) sepia(64%) saturate(3067%) hue-rotate(296deg) brightness(68%) contrast(98%)',
            },
        },
        '& .itemIcon': {
            minWidth: 50,
        },
    },
    menuChildItem: {
        paddingLeft: 70,
        '&.active span': {
            color: '#BE1F93',
            fontWeight: 'bold',
        },
        '&:hover span': {
            color: '#BE1F93',
            fontWeight: 'bold',
        },
        '&:hover': {
            background: 'transparent',
        },
    },
    menuGrandChildItem: {
        paddingLeft: 90,
        '&.active span': {
            color: '#BE1F93',
            fontWeight: 'bold',
        },
        '&:hover span': {
            color: '#BE1F93',
            fontWeight: 'bold',
        },
        '&:hover': {
            background: 'transparent',
        },
    },
    divKatalisBalance: {
        borderRadius: 8,
        border: `1px solid ${GRAY_TITLE}`,
        padding: 10,
        color: GRAY_TITLE,
        fontWeight: 600,
        marginLeft: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        '& .get-more': {
            fontSize: 11.5,
            width: 'fit-content',
            '& a': {
                display: 'flex',
                alignItems: 'center',
            },
            '&:hover': {
                color: PRIMARY,
            },
            '& .icon-get-more': {
                width: 20,
                height: 20,
            },
        },
        '& .expired': {
            fontSize: 11.5,
            '& .link': {
                color: PRIMARY,
            },
        },
        '&.close': {
            margin: '0 10px',
            marginTop: 14,
            alignItems: 'center',
        },
    },
    creditKatalis: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        '& .katalisIcon': {
            width: 18,
            height: 18,
        },
        '& .credit': {
            color: PRIMARY,
            fontSize: 14,
            fontWeight: 'bold',
            display: 'flex',
            alignItems: 'center',
            gap: 5,
        },
        '&.close': {
            '& .katalisIcon': {
                width: 20,
                height: 20,
            },
        },
    },
    refreshKatalisButton: {
        padding: 0,
    },
    refreshKatalisIcon: {
        width: 18,
        height: 18,
    },
    '@keyframes spin': {
        '0%': {
            transform: 'rotate(0deg)',
        },
        '100%': {
            transform: 'rotate(720deg)',
        },
    },
    refreshKatalisIconLoading: {
        width: 18,
        height: 18,
        animation: '$spin 2s linear infinite',
    },
    tooltip: {
        color: 'black !important',
    },
}));

const Sidebar = ({
    activeParentMenu,
    setActiveParentMenu,
    activeChildMenu,
    setActiveChildMenu,
    activeGrandChildMenu,
    setActiveGrandChildMenu,
    open,
    setOpen,
    menuList,
    storeLogo,
    katalisBalance,
    katalisState,
}) => {
    const router = useRouter();
    const classes = useStyles();
    const { t } = useTranslation('common');
    const handleClickParent = (menu) => {
        if (menu.key === (activeParentMenu && activeParentMenu.key)) {
            setActiveParentMenu(null);
        } else {
            setActiveParentMenu(menu);
            if (menu.url) router.push(menu.url);
        }
        setOpen(true);
    };
    const handleClickChild = (menu) => {
        if (menu.key === (activeChildMenu && activeChildMenu.key)) {
            setActiveChildMenu(null);
        } else {
            setActiveChildMenu(menu);
            if (menu.url) router.push(menu.url);
        }
        setOpen(true);
    };
    const handleClickGrandChild = (menu) => {
        if (menu.key === (activeGrandChildMenu && activeGrandChildMenu.key)) {
            setActiveGrandChildMenu(null);
        } else {
            setActiveGrandChildMenu(menu);
            if (menu.url) router.push(menu.url);
        }
        setOpen(true);
    };

    const aclDetail = getLocalStorage('acl') ? JSON.parse(getLocalStorage('acl')) : {};
    const config_acl = getLocalStorage('config_acl') ? JSON.parse(getLocalStorage('config_acl')) : {};

    const storeConfig = storeConfigVar();
    const storeConfigPim = storeConfigPimVar();
    const isExternal = storeConfig?.swiftoms_channel_enable_external_provider === '1';

    useEffect(() => {
        if (open) {
            const key = activeGrandChildMenu?.key || activeGrandChildMenu?.key || activeParentMenu?.key;
            const node = document.getElementById(key);
            if (node) {
                node.scrollIntoView({ behavior: 'instant', block: 'end', inline: 'nearest' });
                node.focus();
            }
        }
    }, [router, open, activeGrandChildMenu, activeGrandChildMenu, activeParentMenu]);

    const SidebarContent = () => (
        <>
            <div
                className={clsx(classes.toolbar, classes.swiftOmsLogo, open ? 'open' : 'close')}
                onClick={() => router.push('/')}
                onKeyDown={() => router.push('/')}
            >
                <img
                    alt=""
                    src={open ? storeLogo?.logo || '/assets/img/swiftoms_logo_expanded.png'
                        : storeLogo?.favicon || '/assets/img/swiftoms_logo_collapsed.png'}
                />
            </div>
            <Hidden smUp>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={() => setOpen(false)}
                    className={clsx(classes.togleMenuButton)}
                >
                    <ChevronLeftIcon className={classes.togleMenuIcon} />
                </IconButton>
            </Hidden>
            <List className={clsx(classes.menuList, open ? 'open' : 'close')}>
                {!katalisState.loading && katalisState.called && katalisState?.status !== null
                    && !!storeConfigPim?.katalis_application_enable && aclDetail?.acl_code?.includes('integration_apps') && (open
                    ? (
                        <div className={classes.divKatalisBalance}>
                            <div className={classes.creditKatalis}>
                                <img className="katalisIcon" alt="" src="/assets/img/katalis.png" />
                                <div className="credit">
                                    {t('common:Credit')}
                                    {': '}
                                    {katalisBalance.loading
                                        ? <Skeleton variant="rect" width={8 * (String(katalisState.balance)?.length || 1)} height={12} animation="wave" />
                                        : katalisState.balance?.toString() ? katalisState.balance : '-'}
                                </div>
                                <Tooltip
                                    title={t('common:Credits_are_used_to_access_the_image_generation__text_generation_using_Katalis_AI')}
                                    classes={{ tooltip: classes.tooltip }}
                                />
                                {katalisBalance.loading
                                    ? <img className={classes.refreshKatalisIconLoading} src="/assets/img/arrow-path.svg" alt="arrow-path" />

                                    : (
                                        <Tooltip
                                            title={t('common:Refresh')}
                                            classes={{ tooltip: classes.tooltip }}
                                        >
                                            <IconButton classes={{ root: classes.refreshKatalisButton }} onClick={katalisBalance.refetch}>
                                                <img className={classes.refreshKatalisIcon} src="/assets/img/arrow-path.svg" alt="arrow-path" />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                            </div>
                            {katalisState?.status === false
                                && (
                                    <div className="expired">
                                        {t('common:Your_account_has_been_disconnected')}
                                        <div>
                                            {t('common:reintegrate')}
                                            {' '}
                                            <Link href="/seller/apps" passHref>
                                                <a className="link" target="_blank" rel="noreferrer">
                                                    {t('common:here')}
                                                </a>
                                            </Link>
                                            .
                                        </div>
                                    </div>
                                )}
                            {!!storeConfigPim?.katalis_purchase_credit_url && (
                                <>
                                    <Divider />
                                    <div className="get-more">
                                        <Link href={storeConfigPim?.katalis_purchase_credit_url} className="link" passHref>
                                            <a target="_blank" rel="noreferrer">
                                                {`${t('common:Get_more_credits')}`}
                                                <KeyboardArrowRightIcon className="icon-get-more" />
                                            </a>
                                        </Link>
                                    </div>
                                </>
                            )}
                        </div>
                    )
                    : (
                        <div className={clsx(classes.divKatalisBalance, 'close')}>
                            <div className={clsx(classes.creditKatalis, 'close')}>
                                <img className="katalisIcon" alt="" src="/assets/img/katalis.png" />
                            </div>
                        </div>
                    )
                )}
                {menuList
                    && menuList.map((menu) => (
                        <div key={menu.key}>
                            {menu.key === 'dashboard' && (
                                <div className={classes.divMenu} id={menu.key} key={menu.key}>
                                    <Link href={`${menu.url}`} key={menu.key}>
                                        <a href={`${menu.url}`}>
                                            <ListItem
                                                button
                                                className={clsx(
                                                    classes.menuItem,
                                                    open ? 'open' : 'close',
                                                    menu.key === (activeParentMenu && activeParentMenu.key) && 'active',
                                                )}
                                                onClick={() => handleClickParent(menu)}
                                            >
                                                <ListItemIcon className="itemIcon">
                                                    <img alt="" src={`/assets/img/layout/${menu.key}.svg`} />
                                                </ListItemIcon>
                                                <ListItemText className="itemText" primary={menu.label} />
                                            </ListItem>
                                        </a>
                                    </Link>
                                </div>
                            )}
                        </div>
                    ))}
                {menuList
                    && menuList.map((menu) => {
                        if ((isExternal && menu.isExternal === false) || (!isExternal && menu.isExternal === true)) {
                            return null;
                        }
                        return (
                            <div id={menu.key} key={menu.key}>
                                {aclDetail && (isMenuAllowed(aclDetail, menu.aclCode) || menu.notInAcl) && !menu.hide && (
                                    <div className={classes.divMenu} key={menu.key}>
                                        {(menu.key === 'tada' || menu.key === 'vendor') ? (
                                            <>
                                                {(menu.key === 'tada' && config_acl?.tada === '1') && (
                                                    <ListItem
                                                        id={menu.key}
                                                        button
                                                        className={clsx(
                                                            classes.menuItem,
                                                            open ? 'open' : 'close',
                                                            menu.key === (activeParentMenu && activeParentMenu.key) && 'active',
                                                        )}
                                                        onClick={() => handleClickParent(menu)}
                                                    >
                                                        <ListItemIcon className="itemIcon">
                                                            <img alt="" src={`/assets/img/layout/${menu.key}.svg`} />
                                                        </ListItemIcon>
                                                        <ListItemText className="itemText" primary={menu.label} />
                                                    </ListItem>
                                                )}
                                                {(menu.key === 'vendor' && config_acl?.vendor === '1') && (
                                                    <ListItem
                                                        id={menu.key}
                                                        button
                                                        className={clsx(
                                                            classes.menuItem,
                                                            open ? 'open' : 'close',
                                                            menu.key === (activeParentMenu && activeParentMenu.key) && 'active',
                                                        )}
                                                        onClick={() => handleClickParent(menu)}
                                                    >
                                                        <ListItemIcon className="itemIcon">
                                                            <img alt="" src={`/assets/img/layout/${menu.key}.svg`} />
                                                        </ListItemIcon>
                                                        <ListItemText className="itemText" primary={menu.label} />
                                                    </ListItem>
                                                )}
                                            </>
                                        ) : (menu?.children?.length
                                            ? (
                                                <ListItem
                                                    id={menu.key}
                                                    button
                                                    className={clsx(
                                                        classes.menuItem,
                                                        open ? 'open' : 'close',
                                                        menu.key === (activeParentMenu && activeParentMenu.key) && 'active',
                                                    )}
                                                    onClick={() => handleClickParent(menu)}
                                                >
                                                    <ListItemIcon className="itemIcon">
                                                        <img alt="" src={`/assets/img/layout/${menu.key}.svg`} />
                                                    </ListItemIcon>
                                                    <ListItemText className="itemText" primary={menu.label} />
                                                </ListItem>
                                                )
                                            : (
                                                <Link href={`${menu.url}`} key={menu.key}>
                                                    <a>
                                                        <ListItem
                                                            id={menu.key}
                                                            button
                                                            className={clsx(
                                                                classes.menuItem,
                                                                open ? 'open' : 'close',
                                                                menu.key === (activeParentMenu && activeParentMenu.key) && 'active',
                                                            )}
                                                            onClick={() => handleClickParent(menu)}
                                                        >
                                                            <ListItemIcon className="itemIcon">
                                                                <img alt="" src={`/assets/img/layout/${menu.key}.svg`} />
                                                            </ListItemIcon>
                                                            <ListItemText className="itemText" primary={menu.label} />
                                                        </ListItem>
                                                    </a>
                                                </Link>
                                                )
                                        )}
                                        {menu && menu.children && menu.children.length && (
                                            <Collapse in={activeParentMenu && activeParentMenu.key === menu.key} timeout="auto" unmountOnExit>
                                                <List component="div" disablePadding>
                                                    {menu.children.map((menuChild) => {
                                                        if ((isExternal && menuChild.isExternal === false) || (!isExternal && menuChild.isExternal === true)) {
                                                            return null;
                                                        }
                                                        return (
                                                            <div id={menuChild.key} key={menuChild.key}>
                                                                {((aclDetail && isMenuAllowed(aclDetail, menuChild.aclCode))
                                                                    || menuChild.notInAcl)
                                                                    && !menuChild.hide && (
                                                                        <>
                                                                            {menu.key === 'pickpack' && (
                                                                                <>
                                                                                    {config_acl?.pickpackWave === '1' && (
                                                                                        <>
                                                                                            {(menuChild.key === 'wavelist'
                                                                                                || menuChild.key === 'wavecreate'
                                                                                                || menuChild.key === 'wavepack') && (
                                                                                                    <Link href={`${menuChild.url}`} key={menuChild.key}>
                                                                                                        <a>
                                                                                                            <ListItem
                                                                                                                button
                                                                                                                key={menuChild.key}
                                                                                                                className={clsx(
                                                                                                                    classes.menuChildItem,
                                                                                                                    menuChild.key
                                                                                                                    === (activeChildMenu
                                                                                                                        && activeChildMenu.key) && 'active',
                                                                                                                )}
                                                                                                                onClick={() => handleClickChild(menuChild)}
                                                                                                            >
                                                                                                                <ListItemText
                                                                                                                    className="itemText"
                                                                                                                    primary={menuChild.label}
                                                                                                                />
                                                                                                            </ListItem>
                                                                                                        </a>
                                                                                                    </Link>
                                                                                                )}
                                                                                        </>
                                                                                    )}
                                                                                    {config_acl?.pickpackBatch === '1' && (
                                                                                        <>
                                                                                            {(menuChild.key === 'batchlist'
                                                                                                || menuChild.key === 'batchcreate'
                                                                                                || menuChild.key === 'batchpack') && (
                                                                                                    <Link href={`${menuChild.url}`} key={menuChild.key}>
                                                                                                        <a>
                                                                                                            <ListItem
                                                                                                                button
                                                                                                                key={menuChild.key}
                                                                                                                className={clsx(
                                                                                                                    classes.menuChildItem,
                                                                                                                    menuChild.key
                                                                                                                    === (activeChildMenu
                                                                                                                        && activeChildMenu.key) && 'active',
                                                                                                                )}
                                                                                                                onClick={() => handleClickChild(menuChild)}
                                                                                                            >
                                                                                                                <ListItemText
                                                                                                                    className="itemText"
                                                                                                                    primary={menuChild.label}
                                                                                                                />
                                                                                                            </ListItem>
                                                                                                        </a>
                                                                                                    </Link>
                                                                                                )}
                                                                                        </>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                            {menu.key === 'configurations' && (
                                                                                <>
                                                                                    {(menuChild.key === 'configurationtada' && config_acl?.tada === '1') && (
                                                                                        <Link href={`${menuChild.url}`} key={menuChild.key}>
                                                                                            <a>
                                                                                                <ListItem
                                                                                                    button
                                                                                                    key={menuChild.key}
                                                                                                    className={clsx(
                                                                                                        classes.menuChildItem,
                                                                                                        menuChild.key
                                                                                                        === (activeChildMenu
                                                                                                            && activeChildMenu.key) && 'active',
                                                                                                    )}
                                                                                                    onClick={() => handleClickChild(menuChild)}
                                                                                                >
                                                                                                    <ListItemText
                                                                                                        className="itemText"
                                                                                                        primary={menuChild.label}
                                                                                                    />
                                                                                                </ListItem>
                                                                                            </a>
                                                                                        </Link>
                                                                                    )}
                                                                                    {(menuChild.key === 'configurationvendorportal' && config_acl?.vendor === '1') && (
                                                                                        <Link href={`${menuChild.url}`} key={menuChild.key}>
                                                                                            <a>
                                                                                                <ListItem
                                                                                                    button
                                                                                                    key={menuChild.key}
                                                                                                    className={clsx(
                                                                                                        classes.menuChildItem,
                                                                                                        menuChild.key
                                                                                                        === (activeChildMenu
                                                                                                            && activeChildMenu.key) && 'active',
                                                                                                    )}
                                                                                                    onClick={() => handleClickChild(menuChild)}
                                                                                                >
                                                                                                    <ListItemText
                                                                                                        className="itemText"
                                                                                                        primary={menuChild.label}
                                                                                                    />
                                                                                                </ListItem>
                                                                                            </a>
                                                                                        </Link>
                                                                                    )}
                                                                                </>
                                                                            )}

                                                                            {!(menu.key === 'pickpack' || menuChild.key === 'configurationtada' || menuChild.key === 'configurationvendorportal') && (
                                                                                menuChild.url
                                                                                ? (
                                                                                    <Link href={`${menuChild.url}`} key={menuChild.key}>
                                                                                        <a>
                                                                                            <ListItem
                                                                                                button
                                                                                                key={menuChild.key}
                                                                                                className={clsx(
                                                                                                classes.menuChildItem,
                                                                                                menuChild.key === (activeChildMenu && activeChildMenu.key)
                                                                                                && 'active',
                                                                                            )}
                                                                                                onClick={() => handleClickChild(menuChild)}
                                                                                            >

                                                                                                <ListItemText className="itemText" primary={menuChild.label} />
                                                                                            </ListItem>
                                                                                        </a>
                                                                                    </Link>
)
                                                                                : (
                                                                                    <ListItem
                                                                                        button
                                                                                        key={menuChild.key}
                                                                                        className={clsx(
                                                                                                classes.menuChildItem,
                                                                                                menuChild.key === (activeChildMenu && activeChildMenu.key)
                                                                                                && 'active',
                                                                                            )}
                                                                                        onClick={() => handleClickChild(menuChild)}
                                                                                    >

                                                                                        <ListItemText className="itemText" primary={menuChild.label} />
                                                                                    </ListItem>
)
                                                                            )}

                                                                            {menuChild && menuChild.children && !!menuChild.children.length && (
                                                                                <Collapse in={activeChildMenu?.key === menuChild.key} timeout="auto" unmountOnExit>
                                                                                    <List component="div" disablePadding>
                                                                                        {menuChild.children.map((menuGrandChild) => (
                                                                                            <div id={menuGrandChild.key} key={menuGrandChild.key}>
                                                                                                {((aclDetail && isMenuAllowed(aclDetail, menuGrandChild.aclCode)) || menuGrandChild.notInAcl) && (
                                                                                                    menuGrandChild.url
                                                                                                        ? (
                                                                                                            <Link href={`${menuGrandChild.url}`} key={menuGrandChild.key}>
                                                                                                                <a>
                                                                                                                    <ListItem
                                                                                                                        button
                                                                                                                        key={menuGrandChild.key}
                                                                                                                        className={clsx(
                                                                                                                            classes.menuGrandChildItem,
                                                                                                                            menuGrandChild.key === (activeGrandChildMenu && activeGrandChildMenu.key)
                                                                                                                            && 'active',
                                                                                                                        )}
                                                                                                                        onClick={() => handleClickGrandChild(menuGrandChild)}
                                                                                                                    >
                                                                                                                        <ListItemText className="itemText" primary={menuGrandChild.label} />
                                                                                                                    </ListItem>
                                                                                                                </a>
                                                                                                            </Link>
                                                                                                        )
                                                                                                        : (
                                                                                                            <ListItem
                                                                                                                button
                                                                                                                key={menuGrandChild.key}
                                                                                                                className={clsx(
                                                                                                                    classes.menuGrandChildItem,
                                                                                                                    menuGrandChild.key === (activeGrandChildMenu && activeGrandChildMenu.key)
                                                                                                                    && 'active',
                                                                                                                )}
                                                                                                                onClick={() => handleClickGrandChild(menuGrandChild)}
                                                                                                            >
                                                                                                                <ListItemText className="itemText" primary={menuGrandChild.label} />
                                                                                                            </ListItem>
                                                                                                        )
                                                                                                )}
                                                                                            </div>
                                                                                        ))}
                                                                                    </List>
                                                                                </Collapse>
                                                                            )}
                                                                        </>
                                                                    )}
                                                            </div>
                                                        );
                                                    })}
                                                </List>
                                            </Collapse>
                                        )}
                                    </div>
                                )}
                            </div>
                        );
                    })}
            </List>
        </>
    );

    const SidebarMobile = () => (
        <Drawer
            variant="temporary"
            open={open}
            onClose={() => setOpen(false)}
            className={clsx(classes.drawer, open ? classes.drawerOpen : classes.drawerClose)}
            classes={{
                paper: clsx(open ? classes.drawerOpen : classes.drawerClose),
            }}
            ModalProps={{ keepMounted: true }}
        >
            {SidebarContent()}
        </Drawer>
    );

    const SidebarDesktop = () => (
        <Drawer
            variant="permanent"
            open={open}
            className={clsx(classes.drawer, open ? classes.drawerOpen : classes.drawerClose)}
            classes={{
                paper: clsx(open ? classes.drawerOpen : classes.drawerClose),
            }}
        >
            {SidebarContent()}
        </Drawer>
    );

    return (
        <>
            <Hidden smUp>{SidebarMobile()}</Hidden>
            <Hidden xsDown>{SidebarDesktop()}</Hidden>
        </>
    );
};

export default Sidebar;
